<style scoped>
a {
  color: #000000 !important;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.prevnext-ticket-btn {
  background-color: #405a61;
  opacity: 1;
}
</style>
<template>
  <v-card
    ref="ticketContainer"
    class="mx-auto"
    max-width="400"
    elevation="4"
    @touchstart="handleTouchStart"
    @touchend="handleTouchEnd"
    style="background-color: #F4F4F5;"
  >
    <v-card-title class="justify-center">
      <strong style="color: #405a61;">{{ index }} of {{ total }}</strong>
    </v-card-title>

    <v-card-subtitle class="text-center">
      Order #{{ ticket.orderId }}
    </v-card-subtitle>

    <v-card-text class="text-center">
      <qrcode-vue :value="ticket.barcode" size="200" level="H" />
      <div class="pt-2">{{ readableBarcode }}</div>
    </v-card-text>

    <v-card-actions class="justify-space-around">
      <v-btn class="prevnext-ticket-btn" icon @click="previousTicket">
        <v-icon color="white">mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn
        color="#E96226"
        dark
        @click="showShareMenu = true"
        style="margin: 0 auto;"
      >
        <v-icon left>mdi-share-variant</v-icon>
        Share This Ticket
      </v-btn>
      <v-menu v-model="showShareMenu" offset-y>
        <template v-slot:activator="{ on }">
          <div v-on="on"></div>
        </template>
        <v-list>
          <v-list-item @click="shareViaSMS">
            <v-list-item-icon>
              <v-icon>mdi-message-text</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Share via SMS</v-list-item-title>
          </v-list-item>
          <v-list-item @click="shareViaEmail">
            <v-list-item-icon>
              <v-icon>mdi-email-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Share via Email</v-list-item-title>
          </v-list-item>
          <v-list-item @click="copyTicketUrl">
            <v-list-item-icon>
              <v-icon>mdi-content-copy</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Copy Ticket URL</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn class="prevnext-ticket-btn" icon @click="nextTicket">
        <v-icon color="white">mdi-chevron-right</v-icon>
      </v-btn>
    </v-card-actions>

    <v-card-text class="pa-4">
      <h2 style="text-align: center;">{{ ticket.eventName }}</h2>
      <h3
        style="text-align: center;"
        v-if="ticket.eventName != 'Festival Guidebook'"
      >
        {{ ticket.eventDate }}
      </h3>
      <h3 style="text-align: center;" class="py-2">{{ ticket.ticketType }}</h3>
      <img
        v-if="ticket.eventTicketImage"
        :src="
          `https://www.tempotickets.com/tempotickets/file_store/${ticket.eventTicketImage}`
        "
        alt="Ticket Image"
        style="width: 100%;"
      />
      <v-list dense>
        <v-list-item v-if="ticket.eventName != 'Festival Guidebook'">
          <v-list-item-icon>
            <v-icon>mdi-map-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <a
                :href="
                  isIOS
                    ? 'https://maps.apple.com/?q=' +
                      ticket.venueAddress +
                      ', ' +
                      ticket.venueCity +
                      ', ' +
                      ticket.venueState
                    : 'geo:0,0?q=' +
                      ticket.venueAddress +
                      ', ' +
                      ticket.venueCity +
                      ', ' +
                      ticket.venueState
                "
                target="_blank"
                rel="noopener noreferrer"
                v-text="ticket.venueName"
              ></a>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-email-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <a
                :href="'mailto:' + ticket.customerEmail"
                v-text="ticket.customerEmail"
              ></a>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-phone-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <a
                :href="'tel:' + ticket.customerPhone"
                v-text="ticket.customerPhone"
              ></a>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-web</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <a
                :href="addProtocol(ticket.customerWebsite)"
                target="_blank"
                rel="noopener noreferrer"
                v-text="ticket.customerWebsite"
              ></a>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import QrcodeVue from "qrcode.vue";

export default {
  name: "mobile-ticket",
  components: {
    QrcodeVue
  },

  props: ["ticket", "onNextTicket", "onPreviousTicket", "index", "total"],
  computed: {
    isIOS() {
      return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    },
    readableBarcode() {
      const code = this.ticket.barcode;
      if (code?.length < 6) {
        // usually bar codes are 8 digits but if that changes we don't want substring errors.
        return code;
      }
      return (
        code.substring(0, 3) +
        " " +
        code.substring(3, 6) +
        " " +
        code.substring(6)
      );
    }
  },
  data() {
    return {
      showShareMenu: false,
      touchstartX: 0,
      touchendX: 0
    };
  },
  methods: {
    handleTouchStart(event) {
      this.touchstartX = event.changedTouches[0].screenX;
    },
    handleTouchEnd(event) {
      this.touchendX = event.changedTouches[0].screenX;
      if (this.touchendX < this.touchstartX) {
        this.nextTicket();
      }

      if (this.touchendX > this.touchstartX) {
        this.previousTicket();
      }
    },
    nextTicket() {
      this.$emit("onNextTicket");
    },
    previousTicket() {
      this.$emit("onPreviousTicket");
    },
    getTicketUrl() {
      return `${window.location.origin}${this.$route.fullPath}/${this.ticket.barcode}`;
    },
    shareViaSMS() {
      const url = this.getTicketUrl();
      const message = `Here's your ticket for ${this.ticket.eventName}: ${url}`;
      window.location.href = `sms:?body=${encodeURIComponent(message)}`;
    },
    shareViaEmail() {
      const url = this.getTicketUrl();
      const subject = `Your ticket for ${this.ticket.eventName}`;
      const body = `Here's your ticket for ${this.ticket.eventName}: ${url}`;
      window.location.href = `mailto:?subject=${encodeURIComponent(
        subject
      )}&body=${encodeURIComponent(body)}`;
    },

    async copyTicketUrl() {
      const url = this.getTicketUrl();
      try {
        await navigator.clipboard.writeText(url);
        this.$root.$emit("showSnackbar", {
          message: "✅ Ticket URL copied to clipboard!",
          color: "success"
        });
      } catch (error) {
        this.$root.$emit("showSnackbar", {
          message: "❌ Failed to copy URL to clipboard",
          color: "error"
        });
      } finally {
        setTimeout(() => {
          this.showShareMenu = false;
        }, 3500); // Keep menu open for toast duration + 0.5s
      }
    },
    addProtocol(url) {
      if (!url.startsWith("http://") && !url.startsWith("https://")) {
        return "http://" + url;
      }
      return url;
    }
  }
};
</script>
